/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Eye({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 3.4c-4.202 0-6.379 3.206-6.896 4.078-.192.324-.192.72 0 1.044C1.621 9.394 3.798 12.6 8 12.6s6.379-3.206 6.896-4.078c.191-.324.191-.72 0-1.044C14.379 6.606 12.202 3.4 8 3.4m0 8c-3.406 0-5.262-2.513-5.809-3.4.353-.572 1.25-1.821 2.758-2.636a3.35 3.35 0 1 0 6.102 0c1.507.815 2.405 2.064 2.758 2.636-.547.887-2.403 3.4-5.809 3.4m0-6.8a2.15 2.15 0 1 0 0 4.3 2.15 2.15 0 0 0 0-4.3" clipRule="evenodd" /></svg>;
}
;